import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface CheckPersonalAccessTokenCreationParams {

}

export interface CheckPersonalAccessTokenCreationResult extends IResult {

}

export class CheckPersonalAccessTokenCreationRequest extends Request<CheckPersonalAccessTokenCreationParams, CheckPersonalAccessTokenCreationResult> {
  constructor(params: CheckPersonalAccessTokenCreationParams) {
    super('checkPersonalAccessTokenCreationIsAllowed', params);
  }
}
